import { PdfFileIcon } from "@images/svgIcons/medias/pdfFileIcon"
import { word } from "@modules/core/utils/i18n"
import { Media } from "@modules/sessionBlock/media/mediaTypes"
import { HUButton } from "@modules/ui/components/huButton"
import { HUText } from "@modules/ui/components/huText"
import { DownloadIcon } from "lucide-react"
import { ComponentProps } from "react"
import { Link } from "react-router-dom"
import { useTheme } from "styled-components"

type MediaDetailsPdfProps = {
  media: Media
} & ComponentProps<"div">

export function MediaDetailsPdf({ media, ...props }: MediaDetailsPdfProps) {
  const theme = useTheme()

  return (
    <div className="flex-1 flex flex-column justify-content-center align-items-center gap-3 relative" {...props}>
      {media.url ? (
        <PdfFileIcon color={theme.neutralColor900} />
      ) : (
        <HUText fontStyle="BM" style={{ overflowWrap: "break-word" }}>
          {word("sessionForm.blocks.add_media.missing_error")}
        </HUText>
      )}
      <HUText fontStyle="BM" style={{ overflowWrap: "break-word" }}>
        {media.filename}
      </HUText>

      <Link to={media.url} target="_blank">
        <HUButton
          size="M"
          colorType="Quaternary"
          type="Rounded"
          className="absolute top-0 right-0 m-auto mr-3 mt-3"
          icon={{ iconView: <DownloadIcon size={24} color={theme.textPrimary} /> }}
          style={{ width: 48, height: 48 }}
          title={word("global.download")}
        />
      </Link>
    </div>
  )
}
